import {
  formatMetricCell,
  METRIC_KEYS,
  METRIC_LABELS,
  WEEK_LABELS,
  type MetricKey,
} from './inboundFlowReportMockData'

interface Props {
  series: Record<MetricKey, Array<number | null>>
}

const LABEL_COL_WIDTH = 176
const DATA_COL_WIDTH = 88

export function InboundFlowMetricsTable({ series }: Props) {
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-white shadow-sm">
      <div className="max-h-[360px] overflow-auto">
        <table className="border-separate text-xs" style={{ borderSpacing: 0 }}>
          <thead>
            <tr>
              <th
                style={{
                  width: LABEL_COL_WIDTH,
                  minWidth: LABEL_COL_WIDTH,
                  left: 0,
                }}
                className="sticky top-0 left-0 z-30 border-r border-b border-border bg-white px-3 py-2 text-left text-xs font-semibold text-foreground"
              >
                <span className="text-[9px] text-muted-foreground">▲</span>
              </th>
              {WEEK_LABELS.map(week => (
                <th
                  key={week}
                  style={{ width: DATA_COL_WIDTH, minWidth: DATA_COL_WIDTH }}
                  className="sticky top-0 z-20 border-r border-b border-border bg-white px-3 py-2 text-right text-xs font-semibold text-foreground"
                >
                  {week}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {METRIC_KEYS.map(key => (
              <tr key={key} className="bg-white hover:bg-muted/20">
                <td
                  style={{
                    width: LABEL_COL_WIDTH,
                    minWidth: LABEL_COL_WIDTH,
                    left: 0,
                  }}
                  className="sticky left-0 z-10 border-r border-b border-border bg-white px-3 py-1.5 text-left font-medium text-foreground"
                >
                  {METRIC_LABELS[key]}
                </td>
                {WEEK_LABELS.map((week, i) => (
                  <td
                    key={week}
                    style={{ width: DATA_COL_WIDTH, minWidth: DATA_COL_WIDTH }}
                    className="border-r border-b border-border px-3 py-1.5 text-right tabular-nums"
                  >
                    {formatMetricCell(key, series[key][i])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
